import React from "react";
import MainSubtitle from "../components/MainSubtitle";
import ContactInformations from "../components/ContactInformations";
import ContactForm from "../components/ContactForm";

function Contact() {

    return (
        <main>
            <MainSubtitle />
            <ContactInformations />
            <ContactForm />
        </main>
    )

}

export default Contact;